import { useEffect } from 'react';
import { Hub } from 'aws-amplify/utils';

export const useAmplifyAuthHub = (
  onSignIn: () => void,
  onFailure: (error: Error) => void,
) => {
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (
        payload.event === 'signInWithRedirect' ||
        payload.event === 'signedIn'
      ) {
        onSignIn();
      }
      if (
        payload.event === 'signInWithRedirect_failure' ||
        payload.event === 'tokenRefresh_failure'
      ) {
        onFailure(new Error('Auth failed'));
      }
    });

    return unsubscribe;
  }, [onSignIn, onFailure]);
};
